import { createAction, createAsyncAction } from "typesafe-actions";

import type { TAdNetworksAbout } from "../types/adNetwork";
import type { Feed } from "../types/feed-base";
import type { SiteInfo } from "../types/siteInfo";
import type { TTopCountries } from "../types/topCountries";

export const fetchFeedsAsyncAction = createAsyncAction(
    "@@sales/feed/FETCH_FEEDS_START",
    "@@sales/feed/FETCH_FEEDS_SUCCESS",
    "@@sales/feed/FETCH_FEEDS_FAILURE",
)<void, Feed[], string | undefined>();

export const fetchTopCountriesAsyncAction = createAsyncAction(
    "@@sales/feed/TOP_COUNTRIES_START",
    "@@sales/feed/TOP_COUNTRIES_SUCCESS",
    "@@sales/feed/TOP_COUNTRIES_FAILURE",
)<void, TTopCountries, string | undefined>();

export const fetchAdNetworksAsyncAction = createAsyncAction(
    "@@sales/feed/AD_NETWORKS_START",
    "@@sales/feed/AD_NETWORKS_SUCCESS",
    "@@sales/feed/AD_NETWORKS_FAILURE",
)<void, TAdNetworksAbout, string | undefined>();

export const fetchSiteInfoAsyncAction = createAsyncAction(
    "@@sales/feed/SITE_INFO_START",
    "@@sales/feed/SITE_INFO_SUCCESS",
    "@@sales/feed/SITE_INFO_FAILURE",
)<void, SiteInfo, string | undefined>();

export const resetSiteInfoAction = createAction("@@sales/feed/RESET_SITE_INFO")();
